import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPatchWithCookies,
  axiosPutWithCookies,
} from './helper';
import { startOfDay, endOfDay } from 'utils/time';

export const fetchPatrolList = ({
  businessClient,
  dateFrom,
  dateTo,
  status,
  search,
  from,
  timezone,
  departmentId,
}) => {
  let query = '/patrols/patrols?sort=eventStartTime:asc&limit=50';
  if (from) query += `&from=${from}`;
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'UTC',
    });

    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timezone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (search) query += `&search=${search}`;

  return axiosGetWithCookies(query);
};

export const fetchPatrolReportDetail = patrolId =>
  axiosGetWithCookies(`/patrols/patrols/${patrolId}`);

export const fetchPatrolListPdf = ({
  businessClient,
  dateFrom,
  dateTo,
  status,
  search,
  timezone,
  language,
  departmentId,
}) => {
  let query = '/patrols/patrols/pdf?sort=eventStartTime:asc&limit=500';

  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }

  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (search) query += `&search=${search}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (language) query += `&language=${language}`;
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }

  return axiosGetWithCookies(query);
};

export const fetchPatrolDetailPdf = ({ id, timezone, language }) => {
  let query = `/patrols/patrols/${id}/pdf`;

  if (timezone) query += `?timezone=${timezone}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};

export const assignPatrolToPersonnel = (personnel, patrolDef) =>
  axiosPostWithCookies(`/patrols/patrols/assign`, {
    data: {
      patroller: personnel,
      patrolDefinition: patrolDef,
    },
  });

export const startVirtualPatrol = virtualPatrolInfo => {
  return axiosPostWithCookies(`/patrols/patrols/start-patrol`, {
    data: {
      patroller: virtualPatrolInfo.patroller,
      firstLocation: virtualPatrolInfo.firstLocation,
    },
  });
};

export const uploadVirtualPatrol = virtualPatrolInfo => {
  return axiosPostWithCookies(`/patrols/patrols`, {
    data: {
      ...virtualPatrolInfo, //Optimise thisß
    },
  });
};

export const postEvidenceTask = task => {
  return axiosPutWithCookies(`/tasks/tasks/`, { data: task });
};

export const abortVirtualPatrol = id => {
  return axiosPatchWithCookies(`/patrols/patrols/${id}/abort`, { data: {} });
};

export const getPatrolById = id => {
  return axiosGetWithCookies(`/patrols/patrols/${id.id}`);
};
